/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partner_Org_Trend_SubtitleInputs */



/**
* | output |
* | --- |
* | "Daily AI usage cost for {name} (last 30 days)." |
*
* @param {Partner_Org_Trend_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_trend_subtitle = /** @type {((inputs: Partner_Org_Trend_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Trend_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tägliche KI-Nutzungskosten für ${i?.name} (letzte 30 Tage).`)
	return /** @type {LocalizedString} */ (`Daily AI usage cost for ${i?.name} (last 30 days).`)
});